import React from 'react';

import { Typography, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import action_library_messages from 'messages/action_library_messages';

import useStyles from './EmptyState.styles';

type Props = {
  onResetFilters: () => void;
  titleMessage?: string[];
  descriptionMessage?: string[];
  resetFiltersMessage?: string[];
};

const EmptyState: React.FC<Props> = ({
  onResetFilters,
  titleMessage = action_library_messages.empty_state.title,
  descriptionMessage = action_library_messages.empty_state.description,
  resetFiltersMessage = action_library_messages.empty_state.reset_filters,
}) => {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <Typography className={styles.title} variant='h5'>
        {t(titleMessage)}
      </Typography>
      <Typography className={styles.description} variant='body1'>
        {t(descriptionMessage)}
      </Typography>
      <Button className={styles.button} color='primary' onClick={onResetFilters} variant='contained'>
        {t(resetFiltersMessage)}
      </Button>
    </div>
  );
};

export default EmptyState;
